import { render, staticRenderFns } from "./PagamentoEletronicoConteudo.vue?vue&type=template&id=e89ce696&scoped=true"
import script from "./PagamentoEletronicoConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./PagamentoEletronicoConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PagamentoEletronicoConteudo.vue?vue&type=style&index=0&id=e89ce696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89ce696",
  null
  
)

export default component.exports